export const LAYER_HIGHLIGHT_FILL_COLOR_HOVER = new Uint8Array([229, 238, 245, 127]) // #E5EEF5 @ 50%
export const LAYER_HIGHLIGHT_FILL_COLOR_PRIMARY = new Uint8Array([3, 111, 226, 20]) // #036FE2 @ 8%
export const LAYER_HIGHLIGHT_FILL_COLOR_SECONDARY = new Uint8Array([255, 255, 255, 255]) // #FFFFFF @ 100%
export const LAYER_HIGHLIGHT_LINE_COLOR_PRIMARY = new Uint8Array([3, 111, 226, 255]) // #036FE2 @ 100%
export const LAYER_HIGHLIGHT_LINE_WIDTH_LIGHT = 1.5
export const LAYER_HIGHLIGHT_LINE_WIDTH_MEDIUM = 2
export const LAYER_HIGHLIGHT_LINE_WIDTH_HEAVY = 4
